/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_RequestInputs */

const en_follow_request = /** @type {(inputs: Follow_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request`)
};

const es_follow_request = /** @type {(inputs: Follow_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitud`)
};

const fr_follow_request = /** @type {(inputs: Follow_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demande`)
};

const de_follow_request = /** @type {(inputs: Follow_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfragen`)
};

const id_follow_request = /** @type {(inputs: Follow_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permintaan`)
};

/** @type {(inputs: Follow_RequestInputs) => LocalizedString} */
const ja_follow_request = en_follow_request;

/** @type {(inputs: Follow_RequestInputs) => LocalizedString} */
const zh_follow_request = en_follow_request;

/** @type {(inputs: Follow_RequestInputs) => LocalizedString} */
const ar_follow_request = en_follow_request;

/** @type {(inputs: Follow_RequestInputs) => LocalizedString} */
const it_follow_request = en_follow_request;

/** @type {(inputs: Follow_RequestInputs) => LocalizedString} */
const ru_follow_request = en_follow_request;

/** @type {(inputs: Follow_RequestInputs) => LocalizedString} */
const pt_follow_request = en_follow_request;

/** @type {(inputs: Follow_RequestInputs) => LocalizedString} */
const ko_follow_request = en_follow_request;

/**
* | output |
* | --- |
* | "Request" |
*
* @param {Follow_RequestInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const follow_request = /** @type {((inputs?: Follow_RequestInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_RequestInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_follow_request(inputs)
	if (locale === "es") return es_follow_request(inputs)
	if (locale === "fr") return fr_follow_request(inputs)
	if (locale === "de") return de_follow_request(inputs)
	if (locale === "ja") return ja_follow_request(inputs)
	if (locale === "zh") return zh_follow_request(inputs)
	if (locale === "ar") return ar_follow_request(inputs)
	if (locale === "id") return id_follow_request(inputs)
	if (locale === "it") return it_follow_request(inputs)
	if (locale === "ru") return ru_follow_request(inputs)
	if (locale === "pt") return pt_follow_request(inputs)
	return ko_follow_request(inputs)
});